const css = `@keyframes _popupEnter_126jf_1 {
  from {
    opacity: 0;
    transform: translateX(-50%) scale(0.95) translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) scale(1) translateY(0);
  }
}
@keyframes _popupExit_126jf_1 {
  from {
    opacity: 1;
    transform: translateX(-50%) scale(1) translateY(0);
  }
  to {
    opacity: 0;
    transform: translateX(-50%) scale(0.95) translateY(4px);
  }
}
@keyframes _shake_126jf_62 {
  0%, 100% {
    transform: translateX(-50%) scale(1) translateY(0) translateX(0);
  }
  20% {
    transform: translateX(-50%) scale(1) translateY(0) translateX(-3px);
  }
  40% {
    transform: translateX(-50%) scale(1) translateY(0) translateX(3px);
  }
  60% {
    transform: translateX(-50%) scale(1) translateY(0) translateX(-2px);
  }
  80% {
    transform: translateX(-50%) scale(1) translateY(0) translateX(2px);
  }
}
._popup_126jf_38 {
  position: fixed;
  transform: translateX(-50%);
  width: 280px;
  padding: 0.75rem 1rem 14px;
  background: #1a1a1a;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.08);
  cursor: default;
  z-index: 100001;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  will-change: transform, opacity;
  opacity: 0;
}
._popup_126jf_38._enter_126jf_52 {
  animation: _popupEnter_126jf_1 0.2s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}
._popup_126jf_38._entered_126jf_55 {
  opacity: 1;
  transform: translateX(-50%) scale(1) translateY(0);
}
._popup_126jf_38._exit_126jf_59 {
  animation: _popupExit_126jf_1 0.15s ease-in forwards;
}
._popup_126jf_38._entered_126jf_55._shake_126jf_62 {
  animation: _shake_126jf_62 0.25s ease-out;
}

._header_126jf_66 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5625rem;
}

._element_126jf_73 {
  font-size: 0.75rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.5);
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
}

._quote_126jf_84 {
  font-size: 12px;
  font-style: italic;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 0.5rem;
  padding: 0.4rem 0.5rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 0.25rem;
  line-height: 1.45;
}

._textarea_126jf_95 {
  width: 100%;
  padding: 0.5rem 0.625rem;
  font-size: 0.8125rem;
  font-family: inherit;
  background: rgba(255, 255, 255, 0.05);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  resize: none;
  outline: none;
  transition: border-color 0.15s ease;
}
._textarea_126jf_95:focus {
  border-color: #3c82f7;
}
._textarea_126jf_95::placeholder {
  color: rgba(255, 255, 255, 0.35);
}
._textarea_126jf_95::-webkit-scrollbar {
  width: 6px;
}
._textarea_126jf_95::-webkit-scrollbar-track {
  background: transparent;
}
._textarea_126jf_95::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

._actions_126jf_125 {
  display: flex;
  justify-content: flex-end;
  gap: 0.375rem;
  margin-top: 0.5rem;
}

._cancel_126jf_132,
._submit_126jf_133 {
  padding: 0.4rem 0.875rem;
  font-size: 0.75rem;
  font-weight: 500;
  border-radius: 1rem;
  border: none;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease, opacity 0.15s ease;
}

._cancel_126jf_132 {
  background: transparent;
  color: rgba(255, 255, 255, 0.5);
}
._cancel_126jf_132:hover {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.8);
}

._submit_126jf_133 {
  color: white;
}
._submit_126jf_133:disabled {
  cursor: not-allowed;
}
._submit_126jf_133:not(:disabled):hover {
  filter: brightness(1.1);
}
._submit_126jf_133:not(:disabled):active {
  transform: scale(0.97);
}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
export default {"popup":"_popup_126jf_38","enter":"_enter_126jf_52","popupEnter":"_popupEnter_126jf_1","entered":"_entered_126jf_55","exit":"_exit_126jf_59","popupExit":"_popupExit_126jf_1","shake":"_shake_126jf_62","header":"_header_126jf_66","element":"_element_126jf_73","quote":"_quote_126jf_84","textarea":"_textarea_126jf_95","actions":"_actions_126jf_125","cancel":"_cancel_126jf_132","submit":"_submit_126jf_133"};